<template>
  <div>
    <EventHeader :event="event" />

    <h2 class="mb-5 text-lg font-medium">Abrechnungen</h2>

    <SettlementTable :events="event.id" />

    <h2 class="mb-5 mt-8 text-lg font-medium">Rechnungen</h2>
    <InvoiceTable :events="event.id" />
  </div>
</template>

<script>
import InvoiceTable from "@/components/InvoiceTable";
import SettlementTable from "@/components/SettlementTable";
import EventHeader from "@/components/EventHeader";

export default {
  props: ["event"],
  components: { InvoiceTable, SettlementTable, EventHeader }
};
</script>
